export default "__VITE_ASSET__B0dPs5CP__"